import React, { useContext, useEffect, useState, useCallback, useRef } from "react";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ImageFullScreenDialog(props) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    props.closeImageFullScreenDialog();
  };

  useEffect(() => {
    setOpen(props.openImageFullScreenDialog);
    console.log('image dialog');
  },[props.openImageFullScreenDialog]);

  return (
    <React.Fragment>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
              sx={{right:0, position: 'fixed'}}
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Typography align='center' sx={{p:2, maxHeight: '90vh'}}>
            <img src={props.openImageFullScreenDialogURL} style={{maxHeight: "100%",maxWidth: "100%",}}/>
        </Typography>
      </Dialog>
    </React.Fragment>
  );
}